"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

import cat from "../assets/images/cat.svg";
import chicken from "../assets/images/chicken.svg";
import chickenProduct from "../assets/images/chickenProduct.svg";
import councilServices from "../assets/images/councilServices.svg";
import cow from "../assets/images/cow.svg";
import cowsProduct from "../assets/images/cowsProduct.svg";
import dog from "../assets/images/dog.svg";
import homePageBanner from "../assets/images/experiment.svg";
import fish from "../assets/images/fish.svg";
import latestContent1 from "../assets/images/latestContent1.svg";
import latestContent2 from "../assets/images/latestContent2.svg";
import latestContent3 from "../assets/images/latestContent3.svg";
import Novitox1 from "../assets/images/Novitox1.svg";
import Novitox2 from "../assets/images/Novitox2.svg";
import Novitox3 from "../assets/images/Novitox3.svg";
import Novitox4 from "../assets/images/Novitox4.svg";
import sheep from "../assets/images/sheep.svg";
import sheepProduct from "../assets/images/sheepProduct.svg";
import { useRouter } from "next/navigation";

export default function Home() {
  const { t } = useTranslation();
  const router = useRouter();
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setSlidesToShow(window.innerWidth > 768 ? 3 : 1);
    }
  }, []);

  const settings2 = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
  };

  const categories = [
    { id: 1, image: sheep, title: t("sheep") },
    { id: 2, image: chicken, title: t("chicken") },
    { id: 3, image: cow, title: t("cow") },
    { id: 4, image: fish, title: t("fish") },
    { id: 5, image: cat, title: t("cat") },
    { id: 6, image: dog, title: t("dog") },
  ];

  return (
    <div className="flex flex-col gap-8 md:gap-10 h-full bg-transparent w-full font-sans text-[#003477] mb-12">
      {/* Hero Section */}
      <section className="relative flex flex-col md:flex-row w-full justify-center m-auto gap-5 py-8">
        <div className="flex relative w-full md:w-fit max-w-[600px] flex-col justify-center items-center md:items-start gap-2 ">
          <span className="text-xl md:text-3xl font-bold text-[#43CA71]">{t("companyName")}</span>
          <span className="text-5xl font-bold">{t("companyTitle")}</span>
          <span className="text-3xl">{t("companySubtitle")}</span>

          <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
            <span
              onClick={() => {
                router.push(`/products`);
              }}
              className="flex w-16 h-16 md:w-24 md:h-24 text-center rounded-2xl text-xl font-bold items-center cursor-pointer"
            >
              {t("categoriesTitle")}
            </span>
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => {
                  router.push(`/product-category/${category.id}`);
                }}
                className="flex flex-col items-center cursor-pointer"
              >
                <div className="w-16 h-16 md:w-28 md:h-28 relative rounded-lg overflow-hidden transition-transform duration-300 hover:scale-105">
                  <Image
                    src={category.image}
                    alt={category.title}
                    layout="fill"
                    objectFit="fill"
                    className="rounded-3xl bg-white p-3 flex flex-col items-center "
                  />
                </div>
              </div>
            ))}
            <div className="flex justify-center m-1 w-16 h-16 md:w-fit md:h-24 bg-[#43CA71] text-white text-center rounded-2xl text-xl font-bold items-center cursor-pointer">
              <span className="p-1.5">{t("orderRegister")}</span>
            </div>
          </div>
        </div>

        <div className="flex relative w-full md:w-[500px] justify-center mt-8 md:mt-0">
          <div className="relative w-64 h-64 md:w-[100%] md:h-[100%]">
            <Image
              className="absolute z-10 border-10 border-white rounded-2xl"
              src={homePageBanner}
              layout="fill"
              objectFit="cover"
              alt="banner"
            />
          </div>
        </div>
      </section>

      {/* About Us */}
      <section className="relative">
        <div className="flex justify-center items-end gap-10 my-[12vh]">
          <div className="flex flex-col gap-2">
            <span className="text-4xl font-bold">{t("aboutUs")}</span>
            <div className="flex justify-center items-end bg-white w-44 h-40 rounded-2xl text-xl font-bold shadow-lg">
              {t("knowledgeRegisteration")}
            </div>
          </div>

          <div>
            <div className="flex justify-center items-center bg-white w-96 h-40 rounded-2xl p-5 text-justify shadow-lg">
              {t("aboutUsDesc")}
            </div>
          </div>

          <div className="flex flex-col gap-8 text-lg font-bold">
            <div className="flex justify-center items-center bg-white w-36 h-16 rounded-2xl text-center px-2 shadow-lg">
              {t("aboutUsOption1")}
            </div>
            <div className="flex justify-center items-center bg-[#43CA71] text-white w-36 h-16 rounded-2xl text-center px-2 shadow-lg">
              {t("aboutUsOption2")}
            </div>
          </div>

          <div className="flex flex-col gap-8 text-lg font-bold">
            <div className="flex justify-center items-center bg-white w-36 h-16 rounded-2xl text-center px-2 shadow-lg">
              {t("aboutUsOption3")}
            </div>
            <div className="flex justify-center items-center bg-white w-36 h-16 rounded-2xl text-center px-2 shadow-lg">
              {t("aboutUsOption4")}
            </div>
          </div>
        </div>

        <div className="bg-[#D1ECFF] absolute top-1 right-0 -z-5 w-[73%] h-[400px] rounded-l-full" />
        <div className="bg-[#D1ECFF] absolute top-1 left-0 -z-5 w-[26%] h-[400px] rounded-r-full" />
      </section>

      {/* Novitox Section */}
      <section className="relative flex w-full justify-center gap-10">
        <div className="flex flex-col w-[40vw] gap-5">
          <div className="flex flex-col w-fit">
            <h2 className="text-xl md:text-2xl font-bold text-[#43CA71] mb-1 mx-6">{t("bind")}</h2>
            <h2 className="text-2xl md:text-3xl font-bold text-[#43CA71] mb-4 mx-12">
              {t("novitox")}
            </h2>
            <p className="mb-6 rounded-2xl mx-6">
              <span className="text-3xl font-bold">{t("novitoxBind")}</span>
            </p>
            <p className="flex w-full text-justify">{t("novitoxDesc")}</p>
          </div>

          <div className="flex w-full justify-between">
            {[Novitox1, Novitox2, Novitox3, Novitox4].map((img, i) => (
              <Image
                key={i}
                src={img}
                alt="product"
                width={100}
                height={130}
                objectFit="cover"
                className="rounded-lg bg-[#EAF6FF]"
              />
            ))}
          </div>
        </div>
        <div className="flex justify-center items-center">
          <div className="flex items-center justify-center p-4 h-auto">
            <div className="flex flex-col w-[260px] bg-white justify-center items-center p-3 pb-5 rounded-lg gap-2 shadow-lg">
              <div className="flex bg-[#EAF6FF] w-full justify-center rounded-lg">
                <Image
                  src={chickenProduct}
                  alt="product"
                  className="rounded-lg bg-[#EAF6FF] w-[220px] h-[220px]"
                />
              </div>
              <span className="flex text-lg w-full">{t("noviHerb")}</span>
              <span className="flex text-sm w-full">{t("noviHerbDesc")}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Novi Herb Section */}
      <section className="relative flex w-full justify-center gap-8">
        <div className="flex justify-center items-center">
          <div className="flex items-center justify-center p-4 h-auto">
            <div className="flex flex-col w-[260px] bg-white justify-center items-center p-3 pb-5 rounded-lg gap-2 shadow-lg">
              <div className="flex bg-[#EAF6FF] w-full justify-center rounded-lg">
                <Image
                  src={chickenProduct}
                  alt="product"
                  className="rounded-lg bg-[#EAF6FF] w-[220px] h-[220px]"
                />
              </div>
              <span className="flex text-lg w-full">{t("noviHerb")}</span>
              <span className="flex text-sm w-full">{t("noviHerbDesc")}</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col w-[40vw] gap-10">
          <div className="flex flex-col w-fit">
            <h2 className="text-2xl md:text-3xl font-bold text-[#43CA71] mb-4">
              {t("noviHerbTitle")}
            </h2>
            <p className="mb-6 rounded-2xl">
              <span className="text-3xl font-bold">{t("noviHerb")}</span>
            </p>
            <p className="flex w-full text-justify">{t("noviHerbFullDesc")}</p>
          </div>

          <div className="flex w-full justify-between">
            {[Novitox1, Novitox2, Novitox3, Novitox4].map((img, i) => (
              <Image
                key={i}
                src={img}
                alt="product"
                width={100}
                height={130}
                objectFit="cover"
                className="rounded-lg bg-[#EAF6FF]"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Latest Content */}
      <section className="flex w-[100%] justify-center my-20">
        <div className="w-[70%]">
          <Slider {...settings2}>
            {[chickenProduct, sheepProduct, chickenProduct, cowsProduct].map((img, i) => (
              <div key={i} className="flex justify-center items-center">
                <div className="flex items-center justify-center p-4 h-auto">
                  <div className="flex flex-col w-[260px] bg-white justify-center items-center p-3 pb-5 rounded-lg gap-2 shadow-lg">
                    <div className="flex bg-[#EAF6FF] w-full justify-center rounded-lg">
                      <Image
                        src={img}
                        alt="product"
                        className="rounded-lg bg-[#EAF6FF] w-[220px] h-[220px]"
                      />
                    </div>
                    <span className="flex text-lg w-full">{t("noviHerb")}</span>
                    <span className="flex text-sm w-full">{t("noviHerbDesc")}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {/* Council Services */}
      <section dir="rtl" className="relative flex items-center">
        <div className="flex flex-col w-[50%] bg-[#43CA71] p-24 rounded-l-2xl text-white gap-8">
          <span className="text-3xl">{t("councilServices")}</span>
          <p className="flex w-[80%]">{t("councilDesc")}</p>
        </div>

        <div className="absolute flex gap-20 right-[45%]">
          <div className="flex flex-col justify-center items-center bg-[#EAF6FF] shadow-lg rounded-xl px-16 py-8 gap-10">
            <Image src={councilServices} alt="product" className="rounded-lg w-[80px] h-[80px]" />
            <span>{t("consultingLivestock")}</span>
          </div>
          <div className="flex flex-col justify-center items-center bg-[#ffffff] shadow-lg rounded-xl px-16 py-8 gap-10">
            <Image src={councilServices} alt="product" className="rounded-lg w-[80px] h-[80px]" />
            <span>{t("consultingPoultry")}</span>
          </div>
        </div>
      </section>

      {/* Latest Blog Section */}
      <section className="flex justify-center items-center">
        <div className="flex flex-col justify-evenly items-center bg-white w-[60%] rounded-xl h-auto p-2 pb-4">
          <div className="flex w-full justify-between pb-5 px-2">
            <span className="text-2xl">{t("latestContent")}</span>
            <div className="flex bg-[#43CA71] w-[80px] text-[#ffffff] justify-center p-1 rounded-lg">
              {t("more")}
            </div>
          </div>

          <div id="cards" className="flex justify-between items-stretch bg-white w-full">
            <div className="flex flex-col items-center justify-between w-[20%]">
              <div className="flex bg-[#43CA71] w-full text-white justify-center px-4 py-2 rounded-lg shadow-lg">
                {t("latestArticles")}
              </div>
              <div className="flex bg-[#43CA71] w-full text-white justify-center px-4 py-2 rounded-lg shadow-lg">
                {t("latestNews")}
              </div>
              <div className="flex bg-[#43CA71] w-full text-white justify-center px-4 py-2 rounded-lg shadow-lg">
                {t("latestEducation")}
              </div>
              <div className="flex bg-[#43CA71] w-full text-white justify-center px-4 py-2 rounded-lg shadow-lg">
                {t("latestPromotion")}
              </div>
            </div>

            <div id="slider" className="flex w-[75%] justify-center items-center">
              <div className="w-[100%]">
                <Slider {...settings2}>
                  {[
                    latestContent1,
                    latestContent2,
                    latestContent3,
                    latestContent1,
                    latestContent3,
                  ].map((img, i) => (
                    <div key={i} className="flex justify-center items-center px-2">
                      <Image src={img} alt="content" className="rounded-lg" />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Need Help */}
      <section className="flex w-full justify-center">
        <div className="flex w-[60%] justify-between items-center">
          <div className="flex flex-col justify-center">
            <span>{t("needHelp")}</span>
            <p>{t("needHelpDesc")}</p>
          </div>
          <div className="flex justify-center gap-10">
            <div className="flex text-center bg-[#D1ECFF] rounded-xl px-4 py-6 items-center justify-center shadow-lg w-36">
              <span>{t("callUs")}</span>
            </div>
            <div className="flex text-center bg-[#D1ECFF] rounded-xl px-4 py-6 items-center justify-center shadow-lg w-36">
              <span>{t("sendTicket")}</span>
            </div>
            <div className="flex text-center bg-[#D1ECFF] rounded-xl px-4 py-6 items-center justify-center shadow-lg w-36">
              <span>{t("faq")}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
